import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-secondary-s py-5 text-center">
      <div className="container pt-3">
        <div className="row">
          <div className="col-lg-3 col-md-2"></div>
          <div className="col-lg-6 col-md-8 text-center text-white">
            <ul className="d-flex gap-4 justify-content-center common-links wow animated fadeInDown">
              <li className="mt-4"><Link to="/privacy-policy" className="text-white fs-11">Privacy Policy</Link></li>
              <li className="mt-4"><Link to="/terms-conditions" className="text-white fs-11">Terms &amp; Conditions</Link></li>
              <li className="mt-4"><Link to="/faq" className="text-white fs-11">FAQs</Link></li>
              <li className="mt-4"><Link to="/contact-us" className="text-white fs-11">Contact Us</Link></li>
            </ul>
            <ul className="d-flex gap-4 justify-content-center social wow animated fadeInDown">
              <li className="mt-4"><a href="#"><i className="fab fa-facebook fs-5"></i></a></li>
              <li className="mt-4"><a href="#"><i className="fab fa-twitter fs-5"></i></a></li>
              <li className="mt-4"><a href="#"><i className="fab fa-youtube fs-5"></i></a></li>
              <li className="mt-4"><a href="#"><i className="fab fa-instagram fs-5"></i></a></li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-2"></div>
        </div>
        <br />
        <hr className="wow animated fadeInDown" />
        <small className="d-block text-white pt-4 fs-11 wow animated fadeInDown">
          Florida Driving Permit &copy; Copyrights 2024. All Rights Reserved
        </small>
      </div>
    </footer>
  );
};

export default Footer;
